<template>
  <Disclosure v-slot="{ open }" as="nav" class="rtl">
    <div
      class="hidden xl:block relative mx-auto max-w-7xl px-2 sm:px-6 md:pr-64 z-40"
    >
      <!-- placeholder -->
      <div class="h-[40px] w-full"></div>

      <div
        class="fixed z-30 w-full xl:w-[calc(100%-196px)] left-0 top-0 flex h-[48px] items-center justify-between bg-primary-900"
      >
        <div
          class="flex flex-row-reverse justify-end w-full h-[40px] pl-[14px] pr-5 items-center"
        >
          <!-- some mobile stuff -->
          <div
            class="absolute inset-y-0 left-0 flex items-center sm:hidden w-full"
          >
            <!-- Mobile menu button-->
            <DisclosureButton
              class="inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            >
              <span class="sr-only">Open main menu</span>
              <Bars3Icon
                v-if="!open"
                aria-hidden="true"
                class="block h-6 w-6"
              />
              <XMarkIcon v-else aria-hidden="true" class="block h-6 w-6" />
            </DisclosureButton>
          </div>
          <!--          TO DO Notifications-->

          <!--          <button-->
          <!--              class="flex flex-row-reverse gap-[6px] items-center"-->
          <!--              @click="$store.dispatch('notifications/toggleShow')"-->
          <!--          >-->
          <!--            <span-->
          <!--                class="material-symbols-rounded text-primary-400 relative text-xl leading-[20px]"-->
          <!--            >notifications-->
          <!--              <span-->
          <!--                  class="h-[5px] w-[5px] rounded-full bg-error block absolute top-[0] right-[0]"-->
          <!--              ></span-->
          <!--              ></span>-->
          <!--            <p class="text-grays-200 font-medium text-sm">2 הודעות שלא נקראו</p>-->
          <!--          </button>-->
          <div class="flex flex-row-reverse items-center gap-[8px]">
            <p class="text-[#D4D4D4] text-xs font-medium hidden lg:block">
              {{ jDate(new Date()) }}, {{ currentTime }}
            </p>
            <h3 class="text-grays-200 font-medium text-lg hidden lg:block">
              שלום {{ fullName }}
            </h3>
          </div>
        </div>
      </div>
    </div>

    <DisclosurePanel class="sm:hidden">
      <div class="space-y-1 px-2 pt-2 pb-3">
        <DisclosureButton
          v-for="item in navigation"
          :key="item.name"
          :aria-current="item.current ? 'page' : undefined"
          :class="[
            item.current
              ? 'bg-gray-900 text-white'
              : 'text-gray-300 hover:bg-gray-700 hover:text-white',
            'block px-3 py-2 rounded-md text-base font-medium',
          ]"
          :href="item.href"
          as="a"
          >{{ item.name }}
        </DisclosureButton>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>
// Import the components from Headless UI
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";

// Import the icons from Heroicons Vue
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import { mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import "dayjs/locale/he";
import hebrewDate from "hebrew-date";
import axiosInstance from "@/helpers/axios";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";

export default {
  components: {
    ButtonSecondary,
    // Register components
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    // Register icons
    Bars3Icon,
    BellIcon,
    XMarkIcon,
  },
  data() {
    return {
      currentTime: new Date().toLocaleTimeString(),
    };
  },
  methods: {
    redirectToOldSite() {
      window.location.replace("https://mishnatyosef.org/login");
    },
    jDate: function (date) {
      const months = [
        "תשרי",
        "חשוון",
        "כסליו",
        "טבת",
        "שבט",
        "אדר א",
        "אדר ב",
        "ניסן",
        "אייר",
        "סיון",
        "תמוז",
        "אב",
        "אלול",
      ];
      const days = [
        "א",
        "ב",
        "ג",
        "ד",
        "ה",
        "ו",
        "ז",
        "ח",
        "ט",
        "י",
        "יא",
        "יב",
        "יג",
        "יד",
        "טו",
        "טז",
        "יז",
        "יח",
        "יט",
        "כ",
        "כא",
        "כב",
        "כג",
        "כד",
        "כה",
        "כו",
        "כז",
        "כח",
        "כט",
        "ל",
      ];
      const years = {
        5781: "תשפ״א",
        5783: "תשפ״ג",
        5782: "תשפ״ב",
        5784: "תשפ״ד",
        5785: "תשפ״ה",
        5786: "תשפ״ו",
        5787: "תשפ״ז",
        5788: "תשפ״ח",
      };
      const y = Number(dayjs(date, "YYYY-MM-DD").format("YYYY"));
      // @ts-ignore
      const m = dayjs(date, "YYYY-MM-DD").format("M") - 1;
      const d = Number(dayjs(date, "YYYY-MM-DD").format("D"));
      // const day = dayjs(date, "YYYY-MM-DD").locale('he').format("dddd");
      // @ts-ignore
      return (
        days[hebrewDate(new Date(y, m, d)).date - 1] +
        " " +
        months[hebrewDate(new Date(y, m, d)).month - 1]
      );
    },
    getTime() {
      setInterval(() => {
        this.currentTime = new Date().toLocaleTimeString("he-IL");
      }, 1000);
    },
    ...mapMutations({
      setFname: "user/setFname",
      setLname: "user/setLname",
      setFullName: "user/setFullName",
    }),
    async setFullNameInTopNav() {
      if (this.fullName.length === 1) {
        const { data } = await axiosInstance.get("/profile");
        this.setCreditsNumber(data.open_transactions_count);
        this.setWeightsNumber(data.open_weights.length);
        this.setFullName(data.full_name);
      }
    },
  },
  computed: {
    ...mapGetters({
      fullName: "user/getFullName",
    }),
  },
  mounted() {
    this.$store.dispatch("user/initializeStore");
    this.getTime();
    this.setFullNameInTopNav();
  },
};
</script>